import React from "react"
import imagePlus from "../images/icon-plus.svg"
import imageMinus from "../images/icon-minus.svg"
import styles from "./faq.module.css"

import posed from "react-pose"

const Content = posed.div({
  closed: { height: 0 },
  open: { height: "auto" },
})

const Icon = posed.div({
  closed: { transform: "rotateZ(90deg)" },
  open: { transform: "rotateZ(180deg)" },
})

export default class FAQ extends React.Component {
  constructor(props) {
    super(props)
    this.state = { open: false }
  }

  handleClick = e => {
    e.preventDefault()
    console.log("click")
    this.setState(state => ({
      open: !state.open,
    }))
  }

  render() {
    const { open } = this.state

    let answerClass = [styles.answer]
    if (this.state.open) {
      answerClass.push(styles.answerOpen)
    }

    return (
      <div className={styles.faq}>
        <hr />
        <a href="#" onClick={this.handleClick} className={styles.question}>
          <h1>{this.props.question}</h1>
          <Icon pose={open ? "open" : "closed"} style={{ display: "flex" }}>
            <img src={open ? imageMinus : imagePlus} style={{ zIndex: "1" }} />
          </Icon>
        </a>
        <Content className={styles.answer} pose={open ? "open" : "closed"}>
          <p>{this.props.answer}</p>
        </Content>
      </div>
    )
  }
}
